import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StockHistoryState } from '../reducers/stock-history.reducer';
import { STOCK_HISTORY_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<StockHistoryState>(STOCK_HISTORY_FEATURE_KEY);

export const selectEntries = createSelector(selectState, (state: StockHistoryState) => state.entries);
export const selectLoaded = createSelector(selectState, (state: StockHistoryState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: StockHistoryState) => state.loading);
export const selectTotal = createSelector(selectState, (state: StockHistoryState) => state.total);
